/**
 * @generated SignedSource<<9fd588a5fbcd632171f86092c5366d3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditMainServices_order$data = {
  readonly items: ReadonlyArray<{
    readonly isService: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"ServicesTable_items">;
  }>;
  readonly " $fragmentType": "OrderEditMainServices_order";
};
export type OrderEditMainServices_order$key = {
  readonly " $data"?: OrderEditMainServices_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditMainServices_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderEditMainServices_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isService",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ServicesTable_items"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "d3ebb6e6990c4e5f9c70e08d87dfa4a2";

export default node;
